var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float_btn_wechart"},[_c('p',[_vm._v("扫码关注公众号")]),_c('img',{attrs:{"src":_vm.qr_qrcode,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }